import { useState } from 'react';
import { Button } from 'components/Elements';
import { Sidebar } from '../components/Sidebar';
import { ChatWindow } from '../components/ChatWindow';
import { useNavigate } from 'react-router-dom';
import { Flag, Home, MapPin } from 'react-feather';
import { MessageCircle } from 'lucide-react';
import { MdBubbleChart, MdComment } from 'react-icons/md';
import { useGlobalConversation } from '../api/getGlobalConversation';

export const Conversations = () => {
  const navigate = useNavigate();
  const [selectedConversation, setSelectedConversation] = useState(null);

  // Load the global broadcast conversation
  const { data: globalData, isLoading: loadingGlobal } = useGlobalConversation({});
  const globalConversation = globalData?.conversation;
  // NOTE: because getGlobalConversation() returns axios response,
  //       data.data.conversation is the JSON payload

  const handleNewBroadcast = () => {
    if (loadingGlobal) return;
    if (globalConversation) {
      setSelectedConversation(globalConversation);
    }
  };

  return (
    <div className="fixed min-h-screen flex items-center justify-center p-4 sm:p-6 md:p-10">
      <div className="fixed w-full max-w-full text-gray-800 px-6 py-12 flex flex-col justify-between">
        <div className="fixed inset-0 flex flex-col ">
          {/* Header bar */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-700 shadow-sm flex-shrink-0">
            <h1 className="text-md font-semibold text-gray-200">Live Support</h1>

            <div className="flex flex-row items-center space-x-2">
              {/* NEW BROADCAST BUTTON (updated) */}
              <Button
                size="sm"
                onClick={handleNewBroadcast}
                disabled={loadingGlobal}
                startIcon={<MdBubbleChart size={12} />}
              >
                Broadcast Message
              </Button>

              <Button size="sm" onClick={() => navigate('/app')} startIcon={<Home size={12} />}>
                Home
              </Button>
            </div>
          </div>

          {/* MAIN LAYOUT */}
          <div className="flex flex-1 overflow-hidden">
            {/* Sidebar */}
            <div className="w-full md:w-[360px] border-r overflow-y-auto">
              <Sidebar
                selectedConversation={selectedConversation}
                onSelectConversation={setSelectedConversation}
              />
            </div>

            {/* Chat window */}
            <div className="flex-1 overflow-hidden bg-gray-50">
              <ChatWindow conversation={selectedConversation} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
